const SET_CONFIGURATION = 'SET_CONFIGURATION';

export { SET_CONFIGURATION };
